import React from 'react'

export default function Page404(props) {
  return (
    <div className='error404'>
      You have entered this page by mistake or without selected country and year to work on. Maybe this document is no
      longer available Please go to home page
    </div>
  )
}
